"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = require("../requests/request");
const contest_1 = require("../models/contest");
class API {
    /**
     * Sign up for an contest
     * @returns {Promise<Contest>} The Promise contains either a device or an APIError if rejected
     */
    static signUp(contest, email, full_name, zip, device, referral) {
        let apiRequest = new request_1.BasicRequest('/contest/' + contest, request_1.HTTPMethod.POST, request_1.APIVersion.v1_2, undefined, {
            email,
            name: full_name,
            zip,
            device,
            referral
        });
        return apiRequest.send(contest_1.Contest).then((data) => {
            return data.data;
        });
    }
}
exports.API = API;
